import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NotificationService from "notifications/api/NotificationService";
import * as ToasterService from "services/toaster";
import { NOTIFICATION_ENUM } from "utils/constants";

import ConfirmationDialog from "components/Dialogs/ConfirmationDialog";
import NotificationDialog from "components/Dialogs/NotificationDialog";

import { getProjectsList } from "slices/projectSlice";
import { useAppDispatch, useAppSelector } from "store";
import { getAllInboxNotificationsList, markAsViewed, notificationsViewSet, openedNotificationSet, selectSlideOut } from "slices/notificationsSlice";
import { Status, StyledIcon } from "./styles";
import FormDescription from "./FormDescription";

const AcceptedStatus = () => (
  <Status>
    <StyledIcon icon="accepted" />
    Accepted
  </Status>
);

const AssignmentReceived = ({ notify }) => {
  const { type, data: { projectId } } = notify;
  const isCompany = type === NOTIFICATION_ENUM.newCompanyAssignmentReceived;

  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const slideOut = useAppSelector(selectSlideOut);

  const handleClose = (event) => {
    event.stopPropagation();
    appDispatch(openedNotificationSet(null));
  };

  const handleCancel = (event) => {
    event.stopPropagation();
    appDispatch(openedNotificationSet(null));
  };

  const closeNotificationList = () => {
    appDispatch(notificationsViewSet(""));
  };

  const handleAcknowledge = async (event) => {
    event.stopPropagation();
    try {
      const { id } = notify;

      await NotificationService.acknowledgeAssignment(id);
      await appDispatch(markAsViewed(notify.id));
      await appDispatch(openedNotificationSet(null));
      await appDispatch(getAllInboxNotificationsList());
      ToasterService.showNotifySuccess("New assignment was successfully confirmed.");
    } catch (error) {
      ToasterService.showNotifyError(error);
    } finally {
      dispatch(getProjectsList({ page: 1 }));
    }
  };

  const redirectToResources = (event) => {
    event.stopPropagation();
    handleClose(event);
    closeNotificationList();
    dispatch(markAsViewed(notify.id));
    navigate(`/projects/${projectId}/resources`);
  };

  if (notify.isViewed && !isCompany) {
    return (
      <NotificationDialog
        open
        projectName={notify.data.projectName}
        title="New Assignment"
        footer={<AcceptedStatus />}
        onClose={handleClose}
      >
        <FormDescription notify={notify} redirectStraightToProject />
      </NotificationDialog>
    );
  }

  const confirmButton = isCompany ? {
    confirmButtonTitle: "Assign Resource",
    onConfirm: redirectToResources,
  } : {
    confirmButtonTitle: "Acknowledge Assignment",
    onConfirm: handleAcknowledge,
  };

  return (
    <ConfirmationDialog
      open
      borderedTitle
      projectName={notify.data.projectName}
      title="New Assignment"
      cancelButtonTitle="Cancel"
      confirmButtonTitle={confirmButton.confirmButtonTitle}
      onClose={handleClose}
      onCancel={handleCancel}
      onConfirm={confirmButton.onConfirm}
      slideOut={slideOut}
      animations
      withScroll
    >
      <FormDescription notify={notify} />
    </ConfirmationDialog>
  );
};

export default AssignmentReceived;
